const USER_ID_KEY = 'mira_user_id';

export function getOrCreateUserId(): string {
    let id = localStorage.getItem(USER_ID_KEY);
    if (!id) {
        id = crypto.randomUUID();
        localStorage.setItem(USER_ID_KEY, id);
    }
    return id;
}
